<template>
  <v-container>
    <v-card outlined :loading="loadingMain" :disabled="loadingMain">
      <v-toolbar flat>
        <v-toolbar-title> Cronograma Físico</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <!-- <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" small dark fab v-bind="attrs" v-on="on">
              <v-icon>mdi-hammer-wrench </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="getExportExcel()">
              <v-list-item-title>
                <v-icon class="mr-2"> mdi-file-excel </v-icon>
                Exportar Excel
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
        <v-spacer></v-spacer>
        <!-- <v-btn
          :loading="loadingSave"
          :disabled="loadingSave"
          rounded
          large
          color="primary"
          style="width: 150px"
          @click="save()"
        >
          Salvar</v-btn
        > -->
        <v-btn
          large
          class="ml-2"
          color="primary"
          rounded
          @click="showAnalyticalSchedule()"
        >
          Cronograma analítico
        </v-btn>
        <v-btn
          large
          class="ml-2"
          color="primary"
          rounded
          @click="showSyntheticSchedule()"
        >
          Cronograma Sintético
        </v-btn>
      </v-toolbar>

      <!-- ETAPAS  -->
      <div v-for="(stage, index) in stages" :key="index">
        <div class="title_table">
          <div style="float: left">
            {{ stage[0].stage.code + " - " + stage[0].stage.name }}
          </div>
          <div style="float: right">

              <v-icon dark @click="showDialogScheduleStage(stage)">mdi-pencil</v-icon>

          </div>
          <!-- <div style="float: right">Total: {{ calcTotal(stage[0].id) }}</div> -->
        </div>
        <!-- COMPOSICOES -->
        <v-card elevation="0" tile>
          <v-simple-table dense outlined>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">SERVIÇO</th>
                  <th class="text-center">DATA</th>
                  <th class="text-right">HH TOTAL</th>
                  <th class="text-right" style="white-space: nowrap">% REALIZADO</th>
                  <th class="text-right" style="width: 100px; white-space: nowrap">
                    HH REALIZADO
                  </th>
                  <th class="text-right" style="white-space: nowrap">A REALIZAR</th>
                  <th class="text-right" style="width: 50px; white-space: nowrap"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in stage"
                  :key="'c-' + item.id + stage[0].id + index"
                >
                  <td>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          {{
                            item.composition.composition_group.code +
                            " - " +
                            item.composition.code +
                            " - " +
                            item.composition.name.substring(0, 150)
                          }}
                        </div>
                      </template>
                      <span>
                        {{
                          item.composition.composition_group.code +
                          " - " +
                          item.composition.code +
                          " - " +
                          item.composition.name
                        }}
                      </span>
                    </v-tooltip>
                  </td>
                  <td style="width: 200px" class="text-center">
                    <div >
                      {{ formatDate(item.date_start) }} - {{ formatDate(item.date_end) }}
                    </div>
                  </td>

                  <td style="width: 150px" class="text-right">
                    <div class="float-right">
                      {{ formatMoney(item.hh_total) }}
                    </div>
                  </td>
                  <td class="text-right">
                    {{ formatMoney(item.percentage_realized) }}
                  </td>
                  <td class="text-right">
                    {{ formatMoney(item.hh_realized) }}
                  </td>
                  <td class="text-right">
                    {{ formatMoney(item.a_realizar) }}
                  </td>
                  <td class="text-right">
                    <div style="text-wrap: nowrap">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="showDialogScheduleService(item)"
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="primary"
                            ><v-icon>mdi-pencil</v-icon></v-btn
                          >
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" style="background: lightgray"></td>
                  <td style="background: lightgray" class="text-right">
                    {{ formatMoney(calcSumHHTotal(stage)) }}
                  </td>
                  <td class="text-right" style="width: 100px; background: lightgray">

                  </td>
                  <td class="text-right" style="width: 100px; background: lightgray">

                  </td>
                  <td class="text-right" style="width: 100px; background: lightgray">

                    {{ formatMoney(calcSumARealizar(stage)) }}
                  </td>
                  <td class="text-right" style="width: 100px; background: lightgray">

                  </td>
                  <!-- <td style="background: lightgray"></td> -->
                </tr>
              </tfoot>
            </template>
          </v-simple-table>
        </v-card>
      </div>
    </v-card>
    <!-- Dialog for scheduling service -->
    <DialogScheduleService
      v-model="dialog_schedule_service"
      @updatePhysicalSchedule="updatePhysicalSchedule"
      :physical_schedule="physical_schedule"
    />

    <!-- Dialog for scheduling service por etapa -->
    <DialogScheduleServiceStage
      v-model="dialog_schedule_service_stage"
      @updatePhysicalSchedule="updatePhysicalScheduleStage"
      :physical_schedule_stage="physical_schedule_stage"
    />
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DialogScheduleService from "./components/DialogScheduleService.vue";
import DialogScheduleServiceStage from "./components/DialogScheduleServiceStage.vue";
export default {
  components: {
    DialogScheduleService,
    DialogScheduleServiceStage,
  },
  data() {
    return {
      dialog_schedule_service_stage: false,
      physical_schedule_stage:[],
      physical_schedule: null,
      selectedComposition: null,
      selectedStage: null,
      loadingMain: false,
      loadingSave: false,
      dialog_schedule_service: false,
      stages: [],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("PhysicalSchedule", ["index"]),
    initialize() {
      this.loadingMain = true;

      this.index()
        .then((response) => {
          this.stages = response.data;
        })
        .catch(() => {
          this.$toast.error("Não foi possível carregar as etapas");
        })
        .finally(() => {
          this.loadingMain = false;
        });
    },
    /**
     * Abri o dialog para especificar o cronograma do serviço
     */
    showDialogScheduleService(item) {
      this.physical_schedule = item;
      this.dialog_schedule_service = true;
    },

    showDialogScheduleStage(stage) {
      this.physical_schedule_stage = stage;
      this.dialog_schedule_service_stage = true;
    },

    /**
     * Atualiza o cronograma físico na tela principal
     */
    updatePhysicalSchedule(physicalSchedule) {
      // Atualiza o cronograma físico somente a linha especifica q foi modificada
      let stage = this.stages[this.physical_schedule.stage_id];
      let compositionIndex = stage.findIndex(
        (composition) =>
          composition.composition.id === this.physical_schedule.composition.id
      );
      this.stages[this.physical_schedule.stage_id][compositionIndex] = physicalSchedule;
    },
    /**
     * atualizar a table a etapa
     */
    updatePhysicalScheduleStage(physicalScheduleStage) {
        this.stages[physicalScheduleStage[0].stage_id] = physicalScheduleStage
    },
    //somatorio de hh total de cada etapa
    calcSumHHTotal(stage) {
      //somatorio da coluna hh_total
      return stage.reduce((acc, item) => {
        return acc + item.hh_total;
      }, 0);
    },
    //somatorio de a realizar de cada etapa
    calcSumARealizar(stage) {
      //somatorio da coluna hh_a_realizar
      return stage.reduce((acc, item) => {
        return acc + item.a_realizar;
      }, 0);
    },
    /**
     * MOSTRA A TELA DE CRONOGRAMA FISICO (ANALITICO)
     */
    showAnalyticalSchedule() {
      this.$router.push({ name: "analytical_schedule" });
    },
    showSyntheticSchedule() {
      this.$router.push({ name: "synthetic_schedule" });
    },

    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
    formatDate(date) {
      if (date) {
        let date_split = date.split("-");
        return date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      }
      return "";
    },
    stringLong(composition_name) {
      if (composition_name.length > 150) {
        return "...";
      }
      return "";
    },
  },
};
</script>

<style scoped>
.title_table {
  font-size: 16px;
  margin-top: 20px;
  width: 100%;
  height: 32px;
  background: #1976d2;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
  padding-top: 3px;
}
</style>
